import React from "react";
import { Field, ErrorMessage, useField } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { TooltipCustom } from "@services/ui-components";

interface TextInputWithButtonProps {
    id: string;
    name: string;
    index: number;
    remove: (index: number) => void;
    label: string;
    infoText?: string;
    disabled?: boolean;
}

const TextInputWithButton: React.FC<TextInputWithButtonProps> = ({
    id,
    name,
    index,
    remove,
    label,
    infoText,
    disabled,
}) => {
    const { t } = useTranslation();
    const [, meta] = useField(name);

    return (
        <Row>
            <Col sm={3} md={2} className="mb-2 mb-sm-0">
                <label htmlFor={id} className="text-dark fs-7 fw-bold py-sm-6">
                    <span className="required-label">{label}</span>
                </label>
            </Col>
            <Col sm={9} md={10}>
                <div className="d-flex align-items-center w-100 gap-2">
                    <Field
                        id={id}
                        name={name}
                        placeholder={t("Add property")}
                        className={`form-control fs-7 ${meta.touched && meta.error ? "is-invalid" : ""}`}
                        maxLength={50}
                        disabled={disabled}
                    />
                    <TooltipCustom placement="bottom" text={t("Delete attribute")}>
                        <Button
                            variant="outline-secondary"
                            className="btn-square"
                            style={{ width: "49px", height: "49px" }}
                            onClick={() => remove(index)}
                            disabled={disabled}
                        >
                            <i className="bi bi-dash text-dark"></i>
                        </Button>
                    </TooltipCustom>
                </div>
                {infoText ? (
                    <div className="mt-1">
                        <span className="fs-7 text-grey">{t(infoText)}</span>
                    </div>
                ) : null}
                <ErrorMessage name={name}>
                    {(msg) => <div className="invalid-feedback d-block">{msg}</div>}
                </ErrorMessage>
            </Col>
        </Row>
    );
};

export default TextInputWithButton;
